import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Stack, Typography } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import * as Roles from '../../../constants/role';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsDocumentos from '../../../store/documento/reducer';
import * as actionsDocumentos from '../../../store/documento/actions';
import { TableV2 } from '../../../components/v2';
import Formulario from './Formulario';

const getModulo = modulo => {
  if (modulo === 'NSIR') return 'Nsir';
  if (modulo === 'FINANCEIRO') return 'Financeiro';
  if (modulo === 'USUARIO') return 'Usuário';
  return 'Configuração';
};

const Documentos = ({ documentos, loadDocumentos, downloadDocumento, authData }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);

  const isAdmin = () => authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  useEffect(() => {
    loadDocumentos();
  }, [loadDocumentos]);

  const columns = [
    { field: 'nome', headerName: 'Nome', flex: 1 },
    { field: 'descricao', headerName: 'Descrição', flex: 1 },
    {
      field: 'modulo',
      headerName: 'Módulo',
      flex: 0.5,
      renderCell: (params) => getModulo(params.row.modulo),
    },
    {
      field: 'ativo',
      headerName: 'Ativo',
      flex: 0.3,
      renderCell: (params) => params.row.ativo ? 'Sim' : 'Não',
    },
  ];

  const headerActions = [];
  if (isAdmin()) {
    headerActions.push({
      label: 'Novo',
      onClick: () => { setOpen(true); setId(null); },
      startIcon: <AddIcon />,
      variant: 'contained',
    });
  }

  return (
    <Box>
      <Stack spacing={3}>
        <Typography variant="h4">Documentos</Typography>

        <TableV2
          rows={documentos}
          columns={columns}
          headerActions={headerActions}
          actions={[
            {
              onClick: id => { setId(id); setOpen(true); },
              icon: <EditIcon />,
              title: 'Editar',
              show: row => isAdmin() && row.modulo !== 'CONFIGURACAO',
            },
            {
              onClick: id => {
                const documento = documentos.filter(d => d.id === id);
                downloadDocumento(documento.length > 0 ? documento[0] : {});
              },
              icon: <CloudDownloadIcon />,
              title: 'Download',
            },
          ]}
        />

        <Formulario
          id={id}
          open={open}
          onClose={isSave => {
            setOpen(false);
            setId(null);
            if (isSave) loadDocumentos();
          }}
        />
      </Stack>
    </Box>
  );
};

Documentos.propTypes = {
  downloadDocumento: PropTypes.func.isRequired,
  loadDocumentos: PropTypes.func.isRequired,
  documentos: PropTypes.array.isRequired,
  authData: PropTypes.object,
};

const mapStateToProps = state => ({
  documentos: selectorsDocumentos.getDocumentos(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsDocumentos
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Documentos));
